import React, { useState, useEffect, useContext } from "react";
import {useParams, useNavigate , Link } from "react-router-dom";
import { WebAssetsContext } from "../App";
import useravatar from '../assets/user.png';
import  { errorToast , successToast , filebasepath , changeDateFotmate , currencySymbol }  from "../functions/Function";
import { ToastContainer, toast, Zoom } from 'react-toastify';

const Userview = (props) => {
  const WebAssets = useContext(WebAssetsContext);
  const api = WebAssets.apiURL;
  const navigate = useNavigate();
  const params = useParams();
  const [id, setId] = useState(params.id);
  const [user, setUser] = useState(null);
  const [isActive, setIsActive] = useState("KYC");
  const [disabled, setDisabled] = useState(false);
  const [inputs, setInputs] = useState({});
  const [paymentinputs, setpaymentInputs] = useState({});
  const getuserdata = async () => {
    const res = await fetch(api + "getUser", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ id: id }),
    });
    let resJson = await res.json();
    return resJson;
  }

  const getUser = async () => {
    try {
      const resJson = getuserdata();
      resJson.then(function (output) {
        if (output.status === true) {
          if(output.response)
          {   setpaymentInputs(values => ({ ...values, status: output.response.payment_option.status}))
              setpaymentInputs(values => ({ ...values, note: output.response.payment_option.note}))
              setInputs(values => ({ ...values, status: output.response.selfi_info.status}))
              setInputs(values => ({ ...values, note: output.response.selfi_info.note}))
          }
          setUser(output.response);
        }
      });
    } catch (err) {
      console.log(err);
    }
  };

  const errortoast = (text) => {
    toast.error(text,
      {
        autoClose: 3000,
        transition: Zoom,
        theme: "colored",
        closeOnClick: true,
        pauseOnHover: true,
      }
    );
  };

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs(values => ({ ...values, [name]: value }))
    
  }

  const handlepaymentChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setpaymentInputs(values => ({ ...values, [name]: value }))
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(true);
    console.log(inputs);
    try {
      let res = await fetch(api + "updateSelfieStatus", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(inputs),
      });
      let output = await res.json();
      setDisabled(false);
      if (res.status === 200) {
        setInputs({'user_id':id})
        if (output.status == true) {
            getUser();
            successToast('Status updated successfully' , 'top-right' , 1500  , true);
        }else if(output.validation == true)
        {
          errorToast(getvalidationErr(output.response) , 'top-right' , 1500  , true);
        }else
        {
          errorToast(output.response , 'top-right' , 1500  , true);
        }

      }
    } catch (err) {
      setDisabled(false);
    }
  };
  

  const getvalidationErr = (errors) => {
    const errorsConvertInArry = Object.values(errors);
    let collectAllValidationErr = [];
    errorsConvertInArry.forEach((error, index) => {
      collectAllValidationErr.push(<div key={index}>{error}</div>);
    });
    const storeAllValidtionErr = (
      <>
        {collectAllValidationErr}
      </>
    );
    errortoast(storeAllValidtionErr);
  }

  const handleUpdatePaymentStatus = async (e) => {
    e.preventDefault();
    setDisabled(true);
    try {
      let res = await fetch(api + "updatepaymentOptionsStatus", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(paymentinputs),
      });
      let output = await res.json();
      setDisabled(false);
      if (res.status === 200) {
        setInputs({'user_id':id})
        if (output.status == true) {
            getUser();
            successToast('Status updated successfully' , 'top-right' , 1500  , true);
        }else if(output.validation == true)
        {
          errorToast(getvalidationErr(output.response) , 'top-right' , 1500  , true);
        }else
        {
          errorToast(output.response , 'top-right' , 1500  , true);
        }

      }
    } catch (err) {
      setDisabled(false);
    }
  };

  useEffect(() => {
    getUser();
    setInputs({'user_id':id})
    setpaymentInputs({'user_id':id})
  }, [id])
  return (
    <>
    {console.log(inputs)}
       <ToastContainer />
      {user != null  ? 
      <div className="section-body">
          <div className="row">
              <div className="col-12">
                  <div className="card">
                        <div className="card-header">
                          <h4>Customer Account  Information</h4>
                          <div className="card-header-form">
                            <button onClick={() => navigate("/admin/users")} className="btn btn-icon icon-left btn-primary"><i className="fas fa-arrow-right"></i> Back</button>
                          </div>
                        </div>
                      <div className="card-body pl-4 pr-4 pb-4 pt-0">
                          <div className="row m-1">
                            <div className="col-sm-12 col-md-9 p-1 mb-2">
                              <div>
                              <span><b>Account Info : </b> </span>
                              {user.status == '1' ? 
                                <button className="btn btn-icon icon-left btn-success mr-2"><i className="fas fa-check"></i> Activated</button>
                              : 
                                    <button  className="btn btn-icon icon-left btn-danger mr-2"><i className="fas fa-times"></i> InActive</button>
                              }

                              {user.is_approved == '1' ?
                                <button className="btn btn-icon icon-left btn-success mr-2"><i className="fas fa-check"></i> Approved</button>
                              : 
                                    <button  className="btn btn-icon icon-left btn-danger mr-2"><i className="fas fa-times"></i> Unapproved</button>
                              } 

                              {user.is_email_verify == '1' ?
                                <button className="btn btn-icon icon-left btn-success mr-2"><i className="fas fa-check"></i> Email Verified</button>
                              : 
                                    <button  className="btn btn-icon icon-left btn-danger mr-2"><i className="fas fa-times"></i> Email Not Verified</button>
                              }

                            {user.phone != '' && 
                            <>
                                {user.is_mobile_verified == '1' ?
                                    <button className="btn btn-icon icon-left btn-success mr-2"><i className="fas fa-check"></i> Mobile Number  Verified</button>
                                  : 
                                        <button  className="btn btn-icon icon-left btn-danger mr-2"><i className="fas fa-times"></i> Mobile Number  Not Verified</button>
                                  } 
                            </>
                            } 




                                    
                                    
                              </div>
                            </div>
                            
                            <div className="col-sm-12 col-md-3 p-1 mb-2 text-right">
                                  <span><b>Wallet : </b></span>
                                  <button className="btn btn-icon icon-left btn-info mr-2"><i className="fas fa-wallet"></i> {currencySymbol() + user.wallet} </button>
                            </div>


                              <div className="col-md-10 col-sm-12 p-1 mb-2">
                                  <div className="custom-grid">
                                      <div className="cw1 font-bolder">Name</div>
                                      <div className="cw">{user.name} </div>
                                  </div>
                                  
                                  <div className="custom-grid">
                                    <div className="cw1 font-bolder">Email</div>
                                    <div className="cw">{user.email}  
                                    &nbsp; &nbsp; 
                                    {user.is_email_verify == '1' ? <div className="badge badge-success">Verified</div> : <div className="badge badge-danger badge-sm">Unverified</div>}</div>
                                  </div>

                                  <div className="custom-grid">
                                    <div className="cw1 font-bolder">Phone</div>
                                    <div className="cw">
                                      { user.phone != '' ? 
                                      <>
                                        {user.phone} 
                                        &nbsp; &nbsp; 
                                        {(user.is_mobile_verified == '1') ? <div className="badge badge-success">Verified</div> : <div className="badge badge-danger badge-sm">Unverified</div>}
                                      </>
                                       : 'Mobile Number No Added'}
                                    </div>
                                  </div>

                                  <div className="custom-grid">
                                    <div className="cw1 font-bolder">City</div>
                                    <div className="cw">{user.city ? user.city: 'No Added' }</div>
                                  </div>

                                  <div className="custom-grid">
                                    <div className="cw1 font-bolder">Address</div>
                                    <div className="cw">{user.address ? user.address: 'No Added' } </div>
                                  </div>

                                  <div className="custom-grid">
                                    <div className="cw1 font-bolder">Registered Date</div>
                                    <div className="cw">{changeDateFotmate(user.created_date, 'DD-MM-YYYY hh:mm:ss a')}</div>
                                  </div>

                                  

                              </div>
                              <div className="col-md-2 col-sm-12  p-1 mb-2">
                                  <div className="font-bolder">Profile</div> 
                                  <div>
                                      {user.profile ? 
                                    <img src={filebasepath()+user.profile} className="img-thumbnail" width={'100%'} />
                                      : <img src={useravatar} className="img-thumbnail" width={'100%'} /> }
                                      
                                    </div> 
                                  </div>
                              
                          </div>
                        </div>

                  </div>
              </div>
              <div className="col-12">
                <div className="card">
                    <div className="padding-20">
                        <ul className="nav nav-tabs" id="myTab2" role="tablist">
                            <li className="nav-item">
                              <Link 
                              className={ isActive == 'KYC' ?  'nav-link  active' : 'nav-link'  } 
                              onClick={()=> setIsActive('KYC') }
                              >KYC</Link>
                            </li>
                            <li className="nav-item">
                              <Link className={ isActive == 'payment' ?  'nav-link  active' : 'nav-link'  } 
                                  onClick={()=> setIsActive('payment') }>
                                    Payment Options
                                  </Link>
                            </li>
                        </ul>

                        <div className="tab-content tab-bordered" id="myTab3Content">
                              <div className={isActive == 'KYC' ? 'tab-pane  fade show active' : 'tab-pane fade' }  id="about" role="tabpanel" aria-labelledby="home-tab2">

                                    {user.selfi_info && user.selfi_info.image != '' ? 
                                      <div>
                                          <h4 className="h4 mb-3">KYC Selfie Photo Information &nbsp;&nbsp;</h4>
                                          <div className="row">
                                            <div className="col-sm-3">
                                            <div className="kycSefiFormupdate">
                                            <h6>Selfie Image</h6>
                                                <div className="selfiephoto-admin">
                                                  <img src={filebasepath()+user.selfi_info.image} className="img-thumbnail" width={'100%'} />
                                                </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 border-right-1">
                                              <div className="kycSefiFormupdate">
                                              <h6>Selfie Information</h6>
                                                  <p className="m-0"><b>Reason :
                                                      </b> {user.selfi_info.note} </p>
                                                      <p className="m-0"><b>ID Type :
                                                      </b> {user.selfi_info.doctype} </p>
                                                      <p className="m-0"><b>ID Number :
                                                      </b> {user.selfi_info.doc_number} </p>
                                                  <p className="m-0"><b>Status : </b>
                                                  {user.selfi_info.status == 'uploaded' &&
                                                        <button className="btn btn-icon icon-left btn-secondary mr-2"><i className="fas fa-upload"></i> Uploaded</button>
                                                    }

                                                    {user.selfi_info.status == 'rejected' &&
                                                          <button  className="btn btn-icon icon-left btn-danger mr-2"><i className="fas fa-times"></i> Rejected</button>
                                                    }

                                                    {user.selfi_info.status == 'accepted' &&
                                                          <button className="btn btn-icon icon-left btn-success mr-2"><i className="fas fa-check"></i> Approved</button>
                                                    }
                                           </p>
                                                  <p className="m-0" ><b>Uploaded Date :</b>   {user.selfi_info.created_date} 
                                                  </p>
                                                </div>
                                            </div>
                                            <div className="col-sm-5">
                                                <div className="kycSefiFormupdate">
                                                    <form method="POST"  onSubmit={handleSubmit}>
                                                    <fieldset>
                                                        <h6>Update Selfie Status</h6>
                                                      <div className="form-group">
                                                          <label>Reason</label>
                                                        
                                                            <textarea 
                                                              name="note"
                                                              placeholder="Reason"
                                                              onChange={handleChange}
                                                              className="form-control"
                                                              defaultValue={inputs.note || ""} 
                                                              value={inputs.note || ""} 
                                                            ></textarea>
                                                      </div>
                                                      <div className="form-group">
                                                              <label>Status<small className="text-danger">*</small></label>
                                                              <div className="row">
                                                                <div className="col-sm-3">
                                                                  <input type="radio" id="statusActive" name="status" className=""
                                                                    value="accepted"
                                                                    checked={inputs.status === 'accepted'}
                                                                    onChange={handleChange}

                                                                  /> 
                                                                  
                                                                  
                                                                  <label htmlFor="statusActive">Approved</label>
                                                                </div>
                                                                <div className="col-sm-3">
                                                                  <input type="radio" id="statusInactive" name="status" className="custom-control-inpu"
                                                                    value="rejected"
                                                                    checked={inputs.status === 'rejected'}
                                                                    onChange={handleChange}
                                                                  /> <label htmlFor="statusInactive">Rejected</label>
                                                                </div>
                                                              </div>
                                                      </div>
                                                      <div className="card-footer text-center">
                                                                        <button className="btn btn-primary mr-1" type="submit" disabled={disabled}> {disabled == false ? 'Submit' : 'Submiting...'} </button>

                                                      </div>
                                                      </fieldset>
                                                    </form>
                                                </div>
                                                
                                            </div>
                                          </div>
                                          
                                      </div>
                                      :
                                      <div>
                                      <h4 className="h4 mb-3">KYC Selfie Photo Information</h4>
                                      <p className="text-center">- Selfie Cant Uploaded - </p>  
                                      </div>
                                      }
                              </div>

                              <div className={isActive == 'payment' ? 'tab-pane  fade show active' : 'tab-pane fade' }  id="settings" role="tabpanel" aria-labelledby="profile-tab2">
                              <h4 className="h4 mb-3">Payment Options Details &nbsp;&nbsp;
                                            
                                            {user.payment_option.status == 'submited' &&
                                                <button className="btn btn-icon icon-left btn-secondary mr-2"><i className="fas fa-upload"></i> Submited</button>
                                            }

                                            {user.payment_option.status == 'rejected' &&
                                                  <button  className="btn btn-icon icon-left btn-danger mr-2"><i className="fas fa-times"></i> Rejected</button>
                                            }

                                            {user.payment_option.status == 'accepted' &&
                                                  <button className="btn btn-icon icon-left btn-success mr-2"><i className="fas fa-check"></i> Approved</button>
                                            }
                                      </h4> 
                                        <div className="row">
                                            <div className="col-sm-7">
                                                <div className="PaymentFormupdate mb-2">
                                                      <h6>1. Bank Transfer Details</h6>
                                                      <div className="row">
                                                          <div className="col-sm-6">Bank Name </div>
                                                          <div className="col-sm-6">
                                                            <div className="field-highlighter mb-2">
                                                              
                                                            { 
                                                              user.payment_option.option1.bank_name ?
                                                              user.payment_option.option1.bank_name
                                                              : "Not Available"
                                                            }
                                                              </div>
                                                          </div>
                                                          <div className="col-sm-6">Bank Account Number</div>
                                                          <div className="col-sm-6">
                                                            <div className="field-highlighter mb-2">
                                                            {
                                                              user.payment_option.option1.bank_account_no  ?
                                                              user.payment_option.option1.bank_account_no 
                                                              : "Not Available"
                                                            }
                                                            </div>
                                                          </div>
                                                      </div>
                                                      
                                                </div>
                                                <div className="PaymentFormupdate mb-2">
                                                      <h6>2. Mobile Number </h6>
                                                      <div className="row">
                                                          <div className="col-sm-6">Mobile Number  </div>
                                                          <div className="col-sm-6">
                                                            <div className="field-highlighter mb-2">
                                                            { 
                                                              user.payment_option.option2.mobile_no ?
                                                              user.payment_option.option2.mobile_no
                                                              : "Not Available"
                                                            }
                                                            </div>
                                                          </div>
                                                        
                                                      </div>
                                                      
                                                </div>
                                            </div>
                                            <div className="col-sm-5">
                                                  <div className="kycSefiFormupdate">
                                                      <form method="POST"  onSubmit={handleUpdatePaymentStatus}>
                                                      <fieldset>
                                                          <h6>Update Payment Options Status</h6>
                                                        <div className="form-group">
                                                            <label>Reason</label>
                                                          
                                                              <textarea 
                                                                name="note"
                                                                placeholder="Reason"
                                                                onChange={handlepaymentChange}
                                                                className="form-control"
                                                                defaultValue={paymentinputs.note || ""} 
                                                                value={paymentinputs.note || ""} 
                                                              ></textarea>
                                                        </div>
                                                        <div className="form-group">
                                                                <label>Status<small className="text-danger">*</small></label>
                                                                <div className="row">
                                                                  <div className="col-sm-3">
                                                                    <input type="radio" id="statusPaymentActive" name="status" className=""
                                                                      value="accepted"
                                                                      checked={paymentinputs.status === 'accepted'}
                                                                      onChange={handlepaymentChange}

                                                                    /> 
                                                                    
                                                                    
                                                                    <label htmlFor="statusPaymentActive">Approved</label>
                                                                  </div>
                                                                  <div className="col-sm-3">
                                                                    <input type="radio" id="statusPaymentInactive" name="status" className="custom-control-inpu"
                                                                      value="rejected"
                                                                      checked={paymentinputs.status === 'rejected'}
                                                                      onChange={handlepaymentChange}
                                                                    /> <label htmlFor="statusPaymentInactive">Rejected</label>
                                                                  </div>
                                                                </div>
                                                        </div>
                                                        <div className="card-footer text-center">
                                                                          <button className="btn btn-primary mr-1" type="submit" disabled={disabled}> {disabled == false ? 'Submit' : 'Submiting...'} </button>

                                                        </div>
                                                        </fieldset>
                                                      </form>
                                                  </div>
                                                  
                                            </div>
                                          </div>   
                                      

                                      

                                      

                              </div>
                        </div>
                    </div>
                  </div>                           
              </div>
          </div>
      </div>
      : '' }
      
    </>

  );
}

export default Userview;
